<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='content' *ngIf='termsAndConditionsDto'>

  <div class='d-flex gap-2 justify-content-center align-items-center'>
    <h1 class='title text-align-center py-sm'>{{ 'shell-app.termsAndConditions.title' | translate }}</h1>
  </div>

  <div class='body overflow-y-scroll px'>
    <div class='template text-align-justify' [innerHTML]="termsAndConditionsDto.template | safe : 'html'"></div>
  </div>

  <div class='footer p text-align-center flex-wrap shadow-lg'>
    @if (agreementVoModel) {
      <span>
        <span>{{ 'shell-app.termsAndConditions.accepted' | translate }}</span>
        <span class='ml-sm'>{{ 'shell-app.termsAndConditions.validFrom' | translate }}:</span>
        <span class='ml-sm color-info bold'>{{ agreementVoModel.validFrom | wellDate: 'dd MMM y, HH:mm' }}</span>
      </span>
      <span
        pTooltip="{{'shell-app.termsAndConditions.retryLater' | translate}}"
        [tooltipDisabled]='agreementVoModel.attachmentUuid !== null'>
        <button pButton label='{{translationSchema.utils.downloadPdf | translate}}'
              icon='fa-solid fa-download'
              class='p-button-text'
              type='button'
              [disabled]='!agreementVoModel.attachmentUuid'
              (click)='downloadPdf(agreementVoModel?.attachmentUuid)' data-testid="translation-schema-utils-download-pdf-translate-btn">
        </button>
      </span>
    } @else {
      <p-skeleton />
    }
  </div>
</div>


